.chip {
  --btn-default-border-radius: var(--border-radius-xs);
  --btn-default-height: 56px;
}
